<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('purchase.purchaseInfo')" name="detail">
          <div
            class="drawer-content"
            :class="
              Permit.canActions('purchaseManage') &&
              purchase &&
              purchase.supplierTenantId != null &&
              !['newly'].includes(purchase.workflowState)
                ? 'with-tab-footer'
                : 'with-tab'
            "
          >
            <el-form
              ref="purchaseForm"
              :model="purchase"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('purchase.serialNo')">
                      <span v-if="purchase.hurry" class="red">
                        ({{ $t("order.hurrySimple") }})
                      </span>
                      {{ purchase.serialNo }}
                      <span
                        v-if="purchase.replaceDeliver"
                        class="orange font10"
                      >
                        ({{ $t("supplier.replaceDeliver") }})
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.workflowState')">
                      <state-label :state="purchase.workflowState">
                        {{ $t("purchaseStates." + purchase.workflowState) }}
                      </state-label>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('menu.suppliers')">
                      {{ purchase.supplierName }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.owner')">
                      {{ purchase.ownerName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">
                      {{ purchase.createAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.handOverAt')">
                      {{ purchase.handOverAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item :label="$t('purchase.giveAt')">
                      {{ purchase.giveAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item
                      :label="$t('purchase.finishAt')"
                      label-width="100px"
                    >
                      {{ purchase.finishAt }}
                    </el-form-item>
                  </el-col>

                  <el-col :span="10">
                    <el-form-item
                      :label="$t('purchase.supplierDeliveryAt')"
                      label-width="140px"
                    >
                      {{ purchase.supplierDeliveryAt }}
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('purchase.settlement')">
                      <span v-if="purchase.settlementId == null">
                        {{ $t("boolean.false") }}
                      </span>
                      <span v-if="purchase.settlementId != null">
                        {{ $t("boolean.true") }}
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="purchase.manualSettleAt != null" :span="6">
                    <el-form-item :label="$t('purchase.manualSettleAt')">
                      {{ purchase.manualSettleAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("order.productInfo") }}
                  <a
                    v-if="purchase.attachment"
                    class="fr blue"
                    target="_blank"
                    :href="purchase.attachment"
                  >
                    {{ $t("action.downloadAttatchment") }}
                  </a>
                </legend>

                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.productNo')">
                      {{ purchase.productNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.category')">
                      {{ purchase.categoryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.brand')">
                      {{ purchase.productBrand }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.color')">
                      <span class="float-left mgr5">{{ purchase.color }}</span>
                      <thumbnail
                        class="mgt5"
                        v-if="purchase.colorImage != null"
                        :images="purchase.colorImage"
                        width="25"
                        height="25"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.size')">
                      {{ purchase.size }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.quantity')">
                      {{ purchase.quantity }} {{ purchase.unit }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    v-if="Permit.canActions('globalPurchasePrice')"
                    :span="8"
                  >
                    <el-form-item :label="$t('purchase.price')">
                      {{ purchase.price }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset
                v-if="
                  purchase.specJson != null &&
                  purchase.specJson != '' &&
                  JSON.parse(purchase.specJson).length != 0
                "
                class="mgb15"
              >
                <legend>{{ $t("product.specJson") }}</legend>
                <el-tag
                  v-for="s in JSON.parse(purchase.specJson)"
                  :key="s.name"
                  type="info"
                  >{{ s.name }}：{{ s.value }}</el-tag
                >
              </fieldset>
              <fieldset v-if="purchase.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail :images="purchase.images" list />
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("product.craftwork") }}</legend>
                <raw-html :content="purchase.craftwork" type="richText" />
              </fieldset>
              <fieldset
                v-if="purchase.remark != null && purchase.remark != ''"
                class="mgb15"
              >
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="purchase.remark" type="richText" />
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("purchase.receiveAdress") }}</legend>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('user.name')">
                      {{ purchase.customerName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('user.phone')">
                      {{ purchase.customerPhone }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('tenant.address')">
                      <span v-if="purchase.country != null">
                        {{ $t("countries." + purchase.customerCountry) }}
                      </span>
                      {{ purchase.customerProvince || "" }}
                      {{ purchase.customerCity || "" }}
                      {{ purchase.customerAddress || "" }}
                      <span
                        v-if="purchase.customerZipcode != null"
                        class="font10"
                      >
                        ({{ purchase.customerZipcode || "" }})
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset v-if="purchase.untreadAt != null" class="mgb15">
                <legend>{{ $t("purchase.untrodInfo") }}</legend>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('purchase.untreadAt')">
                      {{ purchase.untreadAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item :label="$t('purchase.untreadReason')">
                      {{ purchase.untreadReason }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('order.productionInfo')" name="track">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-row :gutter="10" v-loading="tracksLoading">
                <el-col :span="8" v-for="(t, tIndex) in tracks" :key="tIndex">
                  <div style="border: 1px dashed #999" class="mgb10">
                    <div class="mgb10 mgt5 strong center font15">
                      {{ t.woSerialNo }}
                    </div>
                    <el-timeline>
                      <el-timeline-item
                        v-for="(track, index) in t.tracks"
                        :key="index"
                        :color="track.color"
                      >
                        <div :style="'color:' + track.color">
                          {{ track.phase }}
                        </div>
                        <div
                          v-for="(d, dIndex) in track.descs"
                          :key="dIndex"
                          :style="'color:' + track.color"
                        >
                          {{ d }}
                        </div>
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('product.ingredientInfo')"
          name="material"
          v-if="Permit.canActionsChargeEdition('mmsProductView')"
        >
          <div class="drawer-content with-tab">
            <vxe-table
              :data="groupMaterials"
              :span-method="mergeMethod"
              id="bomsTable"
              row-id="id"
              ref="groupBomsTable"
              class="recordsTable mgb15"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              border
              :row-class-name="calculateBgColor"
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="materialSerialNo"
                :title="$t('material.serialNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <div v-if="row.isMerge">
                    {{ row.subjectName }}
                  </div>
                  <span v-else>{{ row.materialSerialNo }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="materialName"
                :title="$t('material.name')"
                min-width="100"
              />
              <vxe-table-column
                field="color"
                :title="$t('material.color')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.color }}({{ row.colorNo }})
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('material.quantity')"
                min-width="80"
              />
            </vxe-table>
            <fieldset
              v-if="
                purchaseExtrainfo &&
                purchaseExtrainfo.remark != null &&
                purchaseExtrainfo.remark != ''
              "
              class="mgb15"
            >
              <legend>{{ $t("text.remark") }}</legend>
              <raw-html :content="purchaseExtrainfo.remark" />
            </fieldset>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      class="drawer-footer"
      v-if="
        Permit.canActions('purchaseManage') &&
        purchase &&
        purchase.supplierTenantId != null &&
        !['newly'].includes(purchase.workflowState)
      "
    >
      <el-button
        type="success"
        size="mini"
        @click="sendMessage"
        v-if="purchase != null"
      >
        {{ $t("action.sendMessage") }}
      </el-button>
    </div>

    <!-- 发消息 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.sendMessage')"
      :close-on-click-modal="false"
      :visible.sync="sendMessageDF"
      width="40%"
    >
      <el-form
        ref="sendMessageObjForm"
        :model="sendMessageObj"
        label-width="60px"
      >
        <el-form-item
          :prop="'content'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.content')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('text.content')"
        >
          <tinymce-editor
            ref="editor"
            v-model="sendMessageObj.content"
            :height="150"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="sendMessageSubmitDoing"
          size="small"
          @click="sendMessageSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="sendMessageDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import RawHtml from "@/components/RawHtml";
import Thumbnail from "@/components/Thumbnail";
import StateLabel from "@/components/StateLabel";
import TinymceEditor from "@/components/TinymceEditor";
import Purchase from "@/api/purchase.js";
import Tenant from "@/api/tenant.js";
import Log from "@/api/log.js";
import PurchaseExtrainfo from "@/api/purchaseExtrainfo.js";
import PurchaseMaterial from "@/api/purchaseMaterial.js";
import Notice from "@/api/notice.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
    Thumbnail,
    StateLabel,
    TinymceEditor,
  },
  data() {
    return {
      activeName: "detail",
      purchase: { workflowState: "newly" },
      logs: [],
      trackDF: false,
      tracks: [],
      tracksLoading: false,
      //配料
      purchaseMaterials: [],
      groupMaterials: [],
      groupMaterialsLoading: false,
      purchaseExtrainfo: {
        remark: null,
      },
      //发消息
      sendMessageDF: false,
      sendMessageObj: {
        content: null,
        customerId: null,
        supplierId: null,
        type: null,
        serialNo: null,
      },
      sendMessageSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    //发消息
    sendMessage() {
      const self = this;
      self.sendMessageObj.type = "cus2SupMes";
      self.sendMessageObj.supplierId = self.purchase.supplierId;
      self.sendMessageObj.serialNo = self.purchase.serialNo;
      self.sendMessageObj.content = null;
      self.sendMessageSubmitDoing = false;
      self.sendMessageDF = true;
    },
    sendMessageSubmit() {
      const self = this;
      self.$refs.sendMessageObjForm.validate((valid) => {
        if (valid) {
          self.sendMessageSubmitDoing = true;
          Notice.send(self.sendMessageObj).then(function (res) {
            if (res.status == 200) {
              self.sysResult(res.data);
              self.sendMessageSubmitDoing = false;
              self.sendMessageDF = false;
            } else {
              slef.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getPurchase();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
      if (this.activeName == "track") {
        this.getTracks();
      }
      if (this.activeName == "material") {
        this.getPurchaseMaterials();
        this.getPurchaseExtrainfo();
      }
    },

    getPurchase() {
      const self = this;
      self.loadingStart();
      self.trackDF = false;
      Purchase.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.purchase = res.data.entity;
          if (self.purchase.supplierTenantId != null) {
            Tenant.findById(self.purchase.supplierTenantId).then(function (
              res
            ) {
              if (res.data.code === 200) {
                const tenant = res.data.entity;
                if (tenant.charge.extendModelNew.includes("mes")) {
                  self.trackDF = true;
                }
              } else {
                self.sysError();
              }
            });
          }
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getLogs() {
      const self = this;
      Log.forEntity("Purchase", self.id).then(function (res) {
        self.logs = res.data;
      });
    },
    getTracks() {
      const self = this;
      self.tracksLoading = true;
      self.tracks = [];
      Purchase.trackSupplierInfos(self.id).then(function (res) {
        if (res.status == 200) {
          let track = res.data;
          if (track.type == "fail") {
            self.$message({
              message: track.message,
              type: "warning",
            });
          } else {
            if (track.data.length != 0) {
              for (const wo of track.data) {
                let obj = {
                  woSerialNo: wo.serialNo,
                  tracks: [],
                };
                obj.tracks.push({
                  phase: "派单",
                  color: "#67C23A",
                  descs: [wo.dispatchAt],
                });
                wo.phasePlans.forEach((pp) => {
                  let objItem = {
                    phase: pp.phaseName,
                    color: pp.phaseMake.startAt
                      ? pp.phaseMake.finishAt
                        ? "#67C23A"
                        : "#E6A23C"
                      : "",
                    descs: pp.manufactures.map((mf) => {
                      let desc = mf.quantity + wo.unit + " 开始:" + mf.startAt;
                      if (mf.endAt) {
                        desc = desc + " 结束:" + mf.endAt;
                      }
                      return desc;
                    }),
                  };
                  obj.tracks.push(objItem);
                });
                obj.tracks.push({
                  phase: "尾查",
                  color:
                    wo.qaQuantity > 0
                      ? wo.qaQuantity == wo.quantity
                        ? "#67C23A"
                        : "#E6A23C"
                      : "",
                  descs: wo.qaQuantity > 0 ? [wo.qaQuantity] : [],
                });
                obj.tracks.push({
                  phase: "出货",
                  color:
                    wo.shipQuantity > 0
                      ? wo.shipQuantity == wo.quantity
                        ? "#67C23A"
                        : "#E6A23C"
                      : "",
                  descs: wo.shipQuantity > 0 ? [wo.shipQuantity] : [],
                });
                self.tracks.push(obj);
              }
            } else {
              self.$message({
                message: "暂无跟踪信息",
                type: "warning",
              });
            }
          }
          self.tracksLoading = false;
        } else {
          self.sysError();
        }
      });
    },
    getPurchaseMaterials() {
      const self = this;
      if (self.purchase != null) {
        PurchaseMaterial.findByPurchaseUuid({
          purchaseUuid: self.purchase.uuid,
        }).then(function (res) {
          if (res.status === 200) {
            self.purchaseMaterials = res.data;
            self.buildTableData();
          } else {
            self.sysError();
          }
        });
      }
    },
    buildTableData() {
      const self = this;
      self.groupMaterials = [];
      if (self.purchaseMaterials.length === 0) {
        return;
      }
      const subjectIds = self.purchaseMaterials.map((b) => b.subjectId);
      const subjectIdsSet = [...new Set(subjectIds)];
      for (const subjectId of subjectIdsSet) {
        const currentSubjectMaterials = self.purchaseMaterials.filter(
          (b) => b.subjectId == subjectId
        );
        self.groupMaterials.push({
          subjectId: subjectId,
          subjectName: currentSubjectMaterials[0].subjectName,
          isMerge: true,
          materials: currentSubjectMaterials,
        });
        for (const material of currentSubjectMaterials) {
          self.groupMaterials.push(material);
        }
      }
    },
    buildMergeCells() {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < this.groupMaterials.length; i++) {
        mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 5 });
        if (this.groupMaterials[i].materials) {
          rowIdx = rowIdx + this.groupMaterials[i].materials.length + 1;
        }
      }
      return mcs;
    },
    mergeMethod({ rowIndex, columnIndex }) {
      const mergeCells = this.buildMergeCells();
      for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
        const { row, col, rowspan, colspan } = mergeCells[mIndex];
        if (row === rowIndex && col === columnIndex) {
          return { rowspan, colspan };
        }
        if (
          rowIndex >= row &&
          rowIndex < row + rowspan &&
          columnIndex >= col &&
          columnIndex < col + colspan
        ) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isMerge ? "light-blue-bg" : "";
    },
    getPurchaseExtrainfo() {
      const self = this;
      PurchaseExtrainfo.findByUuid({
        uuid: self.purchase.uuid,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.purchaseExtrainfo = res.data.entity;
        } else {
          if (res.data.code === 404) {
            //不存在
          } else {
            self.sysError();
          }
        }
      });
    },
  },
};
</script>